import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TaskNavComponent } from '../components/task-nav/task-nav.component';
import { OpenTaskComponent } from '../components/task-open/task-open.component';

@Component({
    selector: 'app-task',
    templateUrl: './task.component.html',
    styleUrls: ['./task.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TaskNavComponent, OpenTaskComponent]
})
export class TaskComponent implements OnInit, OnDestroy {
  constructor() {}

  ngOnInit() {}
  ngOnDestroy(): void {}
}

